/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import { v4 as uuidv4 } from 'uuid';

export const createCard = (props: any = {}) => {
  return {
    title: '',
    attributeType: '',
    ...props,
    isRequired: props?.isRequired,
    id: uuidv4(),
  };
};
